export default __webpack_public_path__ + "54d295f580e6048fce18035fc8a29288.png";